import { Component } from 'preact'
import { ContentType } from '@insided/shared/utils/contentType'
import { PageUnloadContext } from '@insided/shared/services/PageUnloadContext'
// eslint-disable-next-line import/no-internal-modules
import PostEditor from '@insided/deprecated-preact-components/editor/postEditorViaAPI'

export interface AddReplyProps {
  topicId: number
  handleAddReply: () => void
  contentType: ContentType
}

export interface AddReplyState {
  content: string
}

class AddReply extends Component<AddReplyProps, AddReplyState> {
  constructor (props: AddReplyProps) {
    super(props)
    this.state = {
      content: ''
    }
    this.onChange = this.onChange.bind(this)
  }

  onChange (content: string) {
    this.setState({ content })
  }

  render () {
    const { topicId, handleAddReply, contentType } = this.props
    const { content } = this.state

    return (
      <PageUnloadContext.Consumer>
        {({ lock, unlock }) => {
          return (
            <section id='topic-moderation--editor' className='topic-moderation--wysiwyg-editor'>
              <h4><strong>Write a reply</strong></h4>
              <PostEditor
                replyId={null}
                topicId={topicId}
                isControl
                onSuccess={async () => {
                  unlock()
                  await handleAddReply()
                }}
                type={contentType}
                redirect={false}
                isGuest={false}
                disableFileAttachments={false}
                onChange={(content) => {
                  lock(content)
                  this.onChange(content)
                }}
                data={content}
              />
              <br />
            </section>
          )
        }}
      </PageUnloadContext.Consumer>
    )
  }
}

export default AddReply
